import { isNativeRoute } from '../config/nativeScreens';

// On a phone a pre-filled "0" is hard to replace: there is no double-click,
// the caret lands after the zero, and the operator ends up keying "01250".
// On the native floor screens, tapping a number field that holds zero selects
// it, so the first digit typed replaces it — what a native numeric field does.
// A non-zero value is left alone: someone correcting 1250 → 1255 wants the
// caret, not to retype the whole figure.
const PHONE = 'screen and (max-width: 767.98px)';

function isNumberField(el) {
  if (!(el instanceof HTMLInputElement)) return false;
  if (el.type === 'number') return true;
  const mode = el.getAttribute('inputmode');
  return mode === 'decimal' || mode === 'numeric';
}

export function installZeroSelect() {
  if (typeof document === 'undefined' || !window.matchMedia) return () => {};
  const onFocus = (e) => {
    const el = e.target;
    if (!isNumberField(el) || el.readOnly || el.disabled) return;
    if (!window.matchMedia(PHONE).matches || !isNativeRoute(window.location.pathname)) return;
    if (el.value === '' || Number(el.value) !== 0) return;
    // After the browser has placed the caret, or it undoes the selection.
    setTimeout(() => { try { el.select(); } catch { /* not selectable */ } }, 0);
  };
  document.addEventListener('focusin', onFocus);
  return () => document.removeEventListener('focusin', onFocus);
}
